import * as React from 'react';
export const caretLeftSvg = React.forwardRef(function caretLeftSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.14 7.186 9.418 4.13A1 1 0 0 1 11 4.943v6.114a1 1 0 0 1-1.581.813l-4.28-3.056a1 1 0 0 1 0-1.628Z',
    }),
  );
});
caretLeftSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var caretLeft = {
  category: 'icon',
  colorable: true,
  name: 'caretLeft',
  svg: caretLeftSvg,
};
